// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OBko","content":"styles_content__DwN7J"};